import React, {useState} from 'react'
import {useEffect} from 'react'
import {withTranslation} from 'react-i18next'
import {IoAddCircleOutline} from "react-icons/io5"
import {useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import DeleteButton from '../../components/DeleteButton'
import Pagination from '../../components/Pagination'

import Select from '../../components/Select'
import {action, createItem, deleteItem} from '../../services/service'
import swal from "sweetalert";
import ModalAddInsertsAdditional from "../../components/inserts/ModalAddInsertsAdditional";
import {toast} from "react-toastify";
import TemDataTableInline from "../../components/TemDataTableInline";
import EditButton from "../../components/EditButton";
import CopyButton from "../../components/CopyButton";

const headerTable = [{
    name: "name", sort: true
}, {
    name: "default", sort: false
}, {
    name: "necessarily", sort: false
}, <span className="sr-only">Edit</span>,];

const bodyContent = [
    "name",
    "byDefault",
    "necessarily",
    "actions"
]

function Inserts({
                     consistId,
                     selectedRowId,
                     setSelectedRowId,
                     t
                 }) {
    const navigate = useNavigate();
    const {token} = useSelector((state) => state.user);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [itemOffset, setItemOffset] = useState(0);
    const [forcePage, setForcePage] = useState(0);
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [additionalId, setAdditionalId] = useState(null);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });

    const fetchData = async () => {
        const response = await createItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: "", regex: true},
                filter: {consistId: consistId},
            }
        );
        if (response.success) {
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: item.id,
                    name: item.name,
                    byDefault: (
                        <fieldset>
                            <legend className="sr-only">Notifications</legend>
                            <div className="relative flex items-start">
                                <div className="flex items-center h-5">
                                    <input
                                        id="comments"
                                        aria-describedby="comments-description"
                                        name="comments"
                                        type="checkbox"
                                        className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300"
                                        checked={item.byDefault ? item.byDefault : false}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </fieldset>
                    ),
                    necessarily: (
                        <fieldset>
                            <legend className="sr-only">Notifications</legend>
                            <div className="relative flex items-start">
                                <div className="flex items-center h-5">
                                    <input
                                        id="comments"
                                        aria-describedby="comments-description"
                                        name="comments"
                                        type="checkbox"
                                        className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300"
                                        checked={item.necessarily ? item.necessarily : false}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </fieldset>
                    ),
                    actions: (
                        <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                            <CopyButton onclick={() => onCopyRow(item.id)}/>
                            <EditButton onclick={() => editHandler(item.id)}/>
                            <DeleteButton onclick={() => deleteHandler(item.id)}/>
                        </div>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        if (consistId) {
            fetchData();
        }
    }, [consistId, itemOffset, itemsPerPage, data.recordsTotal]);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    const editHandler = async (id) => {
        setIsEdit(true)
        setAdditionalId(id)
        setOpen(true)
    }
    const deleteHandler = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            const response = await deleteItem(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/${id}`,
                token
            );
            if (response.success) {
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };

    const onCopyRow = async (id) => {
        const responseReceived = await swal({
            title: t(`action.copy_item.title`),
            text: t(`action.copy_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/copy/${id}`;
            let res = await action(url, "POST", token);
            if (res.success) {
                fetchData();

            } else {
                navigate("/error", {
                    state: {
                        status: res.status,
                        message: res.message ? res.message : null,
                    },
                });
            }
        }
    };
    const handleClose = () => {
        setOpen(false);
        setIsEdit(false);
        setAdditionalId(null);
    }
    const handleOpen = () => {
        setOpen(true);
        setAdditionalId(null);
    }
    return (
        <>
            <ModalAddInsertsAdditional
                open={open}
                handleClose={handleClose}
                consistId={consistId}
                fetchData={fetchData}
                id={additionalId}
                isEdit={isEdit}
            />
            <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-gray-900">
                    {t(`insert`)}
                </h1>
            </div>
            <div className="flex items-center justify-between">
                <Select setItemsPerPage={setItemsPerPage} itemsPerPage={itemsPerPage}/>
                <button
                    className={`${
                        consistId
                            ? "flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            : "cursor-no-drop flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-300 border border-transparent rounded-md shadow-sm "
                    }   `}
                    onClick={handleOpen}
                    disabled={!consistId}
                >
                    {t('action.add')} {consistId}
                    <IoAddCircleOutline className="w-4 h-4 ml-1"/>
                </button>
            </div>
            <TemDataTableInline
                data={data.data}
                bodyContent={bodyContent}
                headerTable={headerTable}
                rowHandler={(id) => {
                    if (id !== selectedRowId) {
                        setSelectedRowId(id);
                    } else {
                        setSelectedRowId(id);
                    }
                }}
                sortFunction={sortFunction}
            />
            <Pagination
                handlePageClick={handlePageClick}
                pageCount={data.pageCount}
                forcePage={forcePage}
            />
        </>
    )
}

export default withTranslation()(Inserts)
